import { EntityOption } from '@dealstack/frontend/app/pages/Project/MIP/MIPCreate/GeneralDealInputs/useMipEntitySelectController';
import { MipProgrammeEntity } from '@dealstack/frontend/shared/dataExchange/services/mip.service';
import { ProgrammeEntityOption } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/ProgrammeGeneralSettings/ProgrammeEntitiesSection.types';

const normalizeEntityLabel = (label: string) => label.trim().toLocaleLowerCase();

export const getProgrammeEntitySelectOptions = (
	entityOptions: EntityOption[],
	programmeEntities: MipProgrammeEntity[]
): ProgrammeEntityOption[] => {
	const attachedEntityIds = new Set(programmeEntities.map((entity) => entity.entityId));
	const persistedLabels = new Set(
		entityOptions
			.filter((entityOption) => !entityOption.isNew)
			.map((entityOption) => normalizeEntityLabel(entityOption.label))
	);
	const affiliatedLabels = new Set(
		programmeEntities.map((entity) => normalizeEntityLabel(entity.displayName))
	);

	return entityOptions.flatMap((entityOption): ProgrammeEntityOption[] => {
		if (entityOption.isNew) {
			const normalizedLabel = normalizeEntityLabel(entityOption.label);
			if (persistedLabels.has(normalizedLabel) || affiliatedLabels.has(normalizedLabel)) {
				return [];
			}

			return [entityOption];
		}

		const alreadyAffiliated = attachedEntityIds.has(entityOption.value);
		return [
			{
				...entityOption,
				alreadyAffiliated,
				disabled: alreadyAffiliated,
			},
		];
	});
};

export const shouldCreateProgrammeEntityOption = (
	query: string,
	entityOptions: EntityOption[],
	programmeEntities: MipProgrammeEntity[]
): boolean => {
	const normalizedQuery = normalizeEntityLabel(query);
	if (!normalizedQuery) {
		return false;
	}

	return ![
		...entityOptions.map((entity) => entity.label),
		...programmeEntities.map((entity) => entity.displayName),
	]
		.map(normalizeEntityLabel)
		.includes(normalizedQuery);
};
